import React, { ReactNode, useState } from 'react';
import AccountMenu from '../Menus/AccountMenu';
import CurrencySelect from '../Selects/CurrencySelect/CurrencySelect';
import GroupSelect from '../Selects/GroupSelect';
import SlideoutRouter from '../Routing/SlideoutRouter';
import NavPanel from '../Navigation/NavPanel';
import SlideoutRoot from 'ps-components/Slideout/SlideoutRoot';
import SubsiteSelect from '../Selects/SubsiteSelect';
import JBRAuditModal from 'ps-components/Modules/JobRanges/ModelDetailsPage/JBRAuditModal/JBRAuditModal';
import SmartSearch from '../SmartSearch/SmartSearch';
import './DefaultLayout.scss';
import { ChangePasswordModal } from '../Authorization/ChangePasswordModal';
import { IConfig, ISession } from '../../lib/types';
import { RouteComponentProps } from 'react-router';

type DefaultLayoutProps = {
  appLoadFinalProps: boolean
  children: ReactNode
  config: IConfig
  featureFlags: { name: string, enabled: boolean }[]
  history: RouteComponentProps['history']
  launchDarklyFeatureFlags: Record<string, any>
  loginUrl: string
  match: any
  navCollapsed: boolean
  session: ISession
  showSlideout: () => void
  toggleCollapse: () => void
}

const DefaultLayout = (props: DefaultLayoutProps) => {
  const {
    children,
    config,
    featureFlags,
    launchDarklyFeatureFlags,
    navCollapsed,
    session,
    toggleCollapse,
    showSlideout,
    history,
    match,
    appLoadFinalProps
  } = props;

  const [ changePasswordModalOpen, setChangePasswordModalOpen ] = useState(false)

  const { reportViewUser, restrictedUser } = session.user.rights;

  const mainClass = navCollapsed ? 'main' : 'main-nav__open';

  if (!props || !session) return null;
  const orgCode = session.organization.code;
  const pathname = window.location.pathname;
  const isEntryPoint = pathname === config.entryPoint;
  const isNotIframed = isEntryPoint || !pathname.includes('iframe');

  return (
    <div className="app container-fluid">
      {appLoadFinalProps && <SlideoutRouter />}
      <ChangePasswordModal opened={changePasswordModalOpen} onClose={() => setChangePasswordModalOpen(false)} />
      <NavPanel
        featureFlags={featureFlags}
        launchDarklyFeatureFlags={launchDarklyFeatureFlags}
        isNotIframed={isNotIframed}
        navCollapsed={navCollapsed}
        orgCode={orgCode}
        session={session}
        toggleCollapse={toggleCollapse}
        showSlideout={showSlideout}
      />
      <div className="content">
        <header className="header">
          <div className="header__left-actions">
            <div className="header__item--group">
              <GroupSelect />
              <SmartSearch
                reportViewUser={reportViewUser}
                restrictedUser={restrictedUser}
                subsite={session.organization.code}
                showSlideout={showSlideout}
              />
            </div>
          </div>
          <div className="header__right-actions">
            <div className="header__item--currency">
              <CurrencySelect history={history} />
            </div>
            <div className="header__item--profile">
              <AccountMenu config={config} orgCode={orgCode} openChangePasswordModal={() => setChangePasswordModalOpen(true)} />
            </div>
            <div className="header__item--organization">
              <SubsiteSelect />
            </div>
          </div>
        </header>
        <main className={mainClass}>{children}</main>
      </div>
      {appLoadFinalProps && (
        <SlideoutRoot
          history={history}
          match={match}
          launchDarklyFeatureFlags={launchDarklyFeatureFlags}
        />
      )}
      <JBRAuditModal />
    </div>
  );
}

export default DefaultLayout;
